import React from 'react'
import "./ServicesInnerCardsCarousel.css"
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay} from "swiper/modules"

function ServicesInnerCardsCarousel({
    heading="",
    para="",
    cardContent=null
}) {
  return (
    <div className='ServicesInnerCardsCarousel-container standard-padding-space'>
              <div className='container'>
            <div className='text-content text-lg-start text-center'>
                <h3 className='main-heading'>{heading}</h3>
                <p className='body-paragraph'>{para}</p>

            </div>

        </div>
        <div style={{overflowX:"hidden"}}>
             <div className='mt-4 slider-container d-flex'>
              <div className=' mt-3 ms-auto ' style={{width:"80%"}}>


                <Swiper
                    spaceBetween={20}
                    autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                    }}
                    loop={true}
                    // modules={[Autoplay]}
                 
                    breakpoints={{
                        200:{
                        slidesPerView: 1,
                        },
                        1100: {
                        slidesPerView:3,
                        }
                    }}
                    pagination={{ clickable: true }}
                    observer ={true}
                    observeParents={true}
                    parallax={true}
                    className=" px-3 px-md-5 py-4"
                    style={{position:"relative"}}
                    id="service-inner-cards-slider "
                    >
                    
                    
              
                {
                    cardContent && 
                        cardContent.map((ele,ind)=>{
                        return(<>
                            <SwiperSlide style={{height:"auto"}}>
                                <ServiceCard
                                    icon={ele.icon}
                                    heading={ele.heading}
                                    content={ele.content}
                                    btnText={ele.btnText}
                                    btnRef={ele.btnRef}
                            
                                />
                            </SwiperSlide>
        
                            </>)
                        })
                    }
                  
                </Swiper>
                </div>

            </div>
        </div>
    </div>
  )
}


const ServiceCard = ({
        icon,
        heading,
        content,
    }
)=>{
        const navigate= useNavigate()
      return (
        <div className='w-100 d-flex flex-column align-items-start px-4 carousel-card-box pb-5 h-100'>
            <div className='blue-box my-3 p-2 d-flex align-items-center justify-content-center'>
                <img src={icon} className='img-fluid' />
            </div>
                <h5 className='body-heading mb-1' style={{fontSize:"1.2rem"}}>{heading}</h5>
                <p className='body-paragraph mb-0'>{content}</p>
        </div>  
      )
}


export default ServicesInnerCardsCarousel